<div class="modal-header">
    <h5 class="modal-title">Link Your Page to a Facebook Fundraiser</h5>
    <button type="button" class="close" aria-label="Close" (click)="dismissModal('Close click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="card-body facebook-fundraiser-block">
    <div class="facebook-f-logo-block">
        <a><img class="facebook-f-logo" src="assets/img/FB-f-Logo__blue_72.png"/></a>
    </div>
    <div>
        <strong class="text-black">Raise 5x more when you link your fundraising page to Facebook!</strong>
        <span class="text-muted d-block">Invite friends, share updates, track your progress, and collect donations with Facebook</span>
        <facebook-fundraiser-link (linkClicked)="dismissModal('Continue with Facebook click')"></facebook-fundraiser-link>
    </div>
    <hr/>
</div>
